export default __webpack_public_path__ + "static/ecommerce-bded96132e4d174e25f6ed493d139921.png";